import type { StatusGroup } from 'modules/Leads/shared/LeadStatus/LeadStatusV2'
import { LeadDetail } from 'store/types/lead'

const TERMINAL_LEAD_STATUSES = new Set(['converted', 'lost', 'invalid'])

/** Normalized status name when it should render `LeadStatusChipV2` instead of a plain badge. */
export function getLeadStatusChipGroup(
  leadStatusName?: string | null,
): Extract<StatusGroup, 'converted' | 'lost' | 'invalid'> | undefined {
  const normalized = leadStatusName?.toLowerCase().trim() ?? ''
  if (!TERMINAL_LEAD_STATUSES.has(normalized)) return undefined
  return normalized as Extract<StatusGroup, 'converted' | 'lost' | 'invalid'>
}

export const getLeadOwnerName = (leadDetail?: Partial<LeadDetail>): string => {
  const fname = leadDetail?.owner?.fname?.trim() || ''
  const lname = leadDetail?.owner?.lname?.trim() || ''
  const fullName = `${fname} ${lname}`.trim()

  if (fullName) return fullName

  const teamName = leadDetail?.ownerTeam?.name?.trim()
  if (teamName) return teamName

  return 'unassigned_lbl'
}
